import React from 'react';
import WhoWeAre from 'templates/whoWeAre';


const App = () => (
  <WhoWeAre />
);

export default App;
